import React from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { useTranslation } from 'react-i18next'
import { Button } from './shared/Button'

export function ReloadPrompt() {
  const { t } = useTranslation('common')
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {},
    onRegisterError(error) {},
  })

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  if (!offlineReady && !needRefresh) return null

  return (
    <div className="fixed bottom-0 right-0 p-4 m-4 z-50 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 max-w-sm">
      <div className="mb-3 text-sm text-gray-600 dark:text-gray-300">
        {offlineReady ? (
          <span>{t('pwa.offlineReady', 'App prête pour une utilisation hors ligne')}</span>
        ) : (
          <span>{t('pwa.newContent', 'Nouveau contenu disponible, cliquez pour mettre à jour.')}</span>
        )}
      </div>
      <div className="flex space-x-2">
        {needRefresh && (
          <Button size="sm" onClick={() => updateServiceWorker(true)}>
            {t('pwa.reload', 'Rafraîchir')}
          </Button>
        )}
        <Button size="sm" variant="outline" onClick={close}>
          {t('close', 'Fermer')}
        </Button>
      </div>
    </div>
  )
}

